import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';
import menuCatalog from '../assets/images/menu-catalog.svg';
import Upload from '../components/Upload';

function HomePage() {

    const { t, i18n } = useTranslation();

    const breadcrumbs = {
        icon: menuCatalog,
        items: [
            {
                url: 'catalog',
                title: t('myCatalog')
            },
            {
                url: 'file/upload',
                title: t('uploadFile')
            }
        ]
    };

    return(
        <Layout page="catalog" breadcrumbs={breadcrumbs} component={<Upload />} />
    );

}

export default HomePage;